import * as styles from "styles/Common.module.scss";

import { getErrorMessage } from "common/utils/errorUtils";
import { useEffect, createRef } from "react";
import { useInfiniteQuery, useQueryClient } from "react-query";

import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import classNames from "classnames";
import {
  storeScrollPosition,
  fetchStoredScrollPosition,
} from "common/utils/utils";
import { CleanDataUpdateImportBody } from "./CleanDataUpdateImportBody";
import CleanDataUpdateImportHeader from "./CleanDataUpdatImportHeader";
import CustomLoader from "components/common/CustomLoader/CustomLoader";
import NoDataFound from "components/common/NoDataFound/NoDataFound";

export const CleanDataUpdateImportTable = ({
  searchOptions,
  setAreOptionsDisabled,
  currentDashboard,
  partnerId,
  fetchImports,
  hidePromoteLink,
  extraClass,
}) => {
  // * #####################################
  // * Effects
  // * #####################################

  const importTableRef = createRef();

  const tableClasses = classNames(
    "Table_Wrapper",
    styles[extraClass],
    styles.List_Scroll_Table
  );
  const containerClasses = { overflow: "default" };
  const toastId = "toast_import_table_error";

  const { isLoading, isError, error, data, fetchNextPage, hasNextPage } =
    useInfiniteQuery(
      ["imports", searchOptions, partnerId],
      ({ pageParam = 1 }) =>
        fetchImports({
          pageParam,
          pageSize: 20,
          searchOptions,
          urlParams: { partnerId },
        }),
      {
        refetchInterval: 300000,
      }
    );

  console.log(data);

  useEffect(() => {
    setAreOptionsDisabled(isLoading);
  }, [isLoading]);

  useEffect(() => {
    setTimeout(() => {
      fetchStoredScrollPosition("search-clean-data-scrollable", "IMPORTS");
    }, 100);
  }, []);

  const queryClient = useQueryClient();

  const invalidateQuery = () => queryClient.invalidateQueries("clean-data");
  console.log(invalidateQuery);

  // * #####################################
  // * Loading and Error States
  // * #####################################

  if (isLoading) {
    return (
      <CustomLoader containerClasses={styles.Tab_Content_Flex_Container} />
    );
  }

  // * To prevent duplicate toast messages
  if (isError) {
    toast.error(getErrorMessage(error, "Cannot fetch imports"), {
      toastId: toastId,
    });
  }

  // * Manipulate paginated response data
  const imports = data?.pages.flatMap((page) => page.data.payload);
  const lastPage = data?.pageParams.at(-1) || 1;

  // * #####################################
  // * No data state
  // * #####################################
  if (!imports || imports?.length === 0) {
    return (
      <NoDataFound
        {...{
          title: "No imports found for requested filter",
          wrapperClasses: styles.Tab_Content_Flex_Container,
        }}
      />
    );
  }

  return (
    <section
      id="search-clean-data-scrollable"
      className={tableClasses}
      ref={importTableRef}>
      <InfiniteScroll
        style={containerClasses}
        loader={<h4 className="Font_H8">Loading...</h4>}
        next={fetchNextPage}
        dataLength={lastPage * imports?.length}
        hasMore={hasNextPage}
        onScroll={(event) => storeScrollPosition(event, "CLEAN_DATA_LIST")}
        scrollableTarget="search-clean-data-scrollable">
        <table className="Table overflow-auto">
          <CleanDataUpdateImportHeader
            {...{ searchOptions, currentDashboard }}
          />
          <CleanDataUpdateImportBody
            {...{
              imports,
              searchOptions,
              currentDashboard,
              refreshImports: invalidateQuery,
              hidePromoteLink,
            }}
          />
        </table>
      </InfiniteScroll>
    </section>
  );
};
